import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { graphql } from 'gatsby';
import {
  RewardImage,
  StyledContentBlock,
  StyledSection,
  Subtitle,
  Textwrapper,
  Title,
  Titlewrapper,
  Contentwrapper,
} from './styled';

const Rewards = () => {
  const { formatMessage } = useIntl();
  const imagesrc = formatMessage({ id: 'home.rewards.image.src' });
  const imagealt = formatMessage({ id: 'home.rewards.image.alt' });
  return (
    <StyledSection>
      <StyledContentBlock>
        <Contentwrapper>
          <RewardImage src={imagesrc} alt={imagealt} />
          <Textwrapper>
            <Titlewrapper>
              <Title>
                <FormattedMessage id="home.rewards.title" />
              </Title>
              <Subtitle>
                <FormattedMessage id="home.rewards.subtitle" />
              </Subtitle>
            </Titlewrapper>
          </Textwrapper>
        </Contentwrapper>
      </StyledContentBlock>
    </StyledSection>
  );
};

export default Rewards;

export const headerFragment = graphql`
  fragment Rewards on Json {
    rewards {
      title
      subtitle
      image {
        src
        alt
      }
    }
  }
`;
